import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import type { CancelMultiDetails } from './models/JobSharedInterfaces';

interface AllocateMultiCancelProps {
    cancelDetails: CancelMultiDetails;
    showModal: boolean;
    hideModal(): void;
    allocateExisting(): void;
}

interface CancelMultiModal {
    loading: boolean;
}
export default class AllocateCancelModal extends React.Component<AllocateMultiCancelProps, CancelMultiModal> {
    constructor(props: AllocateMultiCancelProps) {
        super(props);
        this.state = {
            loading: false
        }
    }

    hideModal = () => {
        this.props.hideModal();
    }

    allocateExisting = (e: any) => {
        e.preventDefault();

        this.props.allocateExisting();
    }

    cancel = (e: any) => {
        e.preventDefault();

        this.props.hideModal();
    }

    render() {
        let contents = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderDetails();


        return (<div>
            {contents}
        </div>);
    }

    renderDetails = () => {
        let cancelDetails = this.props.cancelDetails;

        return (
            <div className="static-modal">
                <Modal show={this.props.showModal} onHide={this.hideModal}>
                    <Modal.Header className="modal__header--colour">
                        <Modal.Title>Confirm Cancel {cancelDetails.item}</Modal.Title>
                        <button type="button" className="close" onClick={this.hideModal}>&times;</button>
                    </Modal.Header>
                    <Modal.Body>
                        <div>
                            Cancelling this item will allocate the remaining qty of {cancelDetails.cancelQty} to existing item scheduled on {cancelDetails.scheduleDateFormatted} in order to schedule the correct total quantity
                        </div>
                    </Modal.Body>

                    <Modal.Footer>
                        <button className="popup-button--no" onClick={this.hideModal}>Don't Cancel</button>
                        <button className="popup-button--yes" onClick={this.allocateExisting}>Continue Cancelling</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }



}